import React from "react";
import "./Layout.scss";
import { Outlet } from "react-router-dom";

function Layout() {
  return (
    <div className="layout">
      <div className="header">
        <div className="container">
          <h2>Payment Mode</h2>
        </div>
      </div>
      <div className="layout_body">
        <Outlet />
      </div>
    </div>
  );
}

export default Layout;
